"use strict";module.exports=function(){return!("undefined"!=typeof window&&window.document)};
